import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { exchangeSession } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    const target = location.pathname && location.pathname !== "/" ? location.pathname : "/intro";
    exchangeSession(sessionId)
      .then((u) => { setUser(u); navigate(target, { replace: true }); })
      .catch(() => navigate("/", { replace: true }));
  }, [location, navigate, setUser]);

  return null;
}
